import { API_BASE_URL } from "../config";
import type { Environment, SignalingServerResponse } from "../types";

// Proxied through our own API (see backend/functions/demand) rather than
// fetched directly from the Signaling Server, which doesn't allow CORS from
// this site's origin and isn't a system this repo owns/can configure.
export async function fetchDemand(environment: Environment): Promise<SignalingServerResponse> {
  const response = await fetch(`${API_BASE_URL}/demand/${environment}`);
  if (!response.ok) {
    throw new Error(`Demand lookup failed for '${environment}': ${response.status}`);
  }
  return response.json();
}
